import { createVNode as o, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/AuthorityManageFilledStandard.js";
import d from "../components/PfIcon.js";
const t = (r, a) => {
  const e = {
    ...r,
    ...a.attrs
  };
  return o(d, i(e, {
    icon: n
  }), null);
};
t.displayName = "AuthorityManageFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
